import { render } from "./ThePhanLoaiDiaDiem.vue?vue&type=template&id=dd310ad6"
import script from "./ThePhanLoaiDiaDiem.vue?vue&type=script&lang=js"
export * from "./ThePhanLoaiDiaDiem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__